import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntNsDnsStatusColorDirective} from "../../extensions/int-ns-dns-status/int-ns-dns-status-color.directive";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntNsDnsStatusColorDirective
  ],
  exports: [
    IntNsDnsStatusColorDirective
  ]
})
export class IntNsDnsStatusModule {}
